// extracted by mini-css-extract-plugin
module.exports = {"eventItemsList":"HistoricEvents_eventItemsList__3MBK9","eventItem":"HistoricEvents_eventItem__1KOlN"};